import React from "react";
import { Modal, Tabs } from "antd";
import { TypesEditor } from "./TypesEditor";

// One Modal, one tab per type dimension — each tab is a fully independent
// TypesEditor (own fetch/save), so saving one dimension doesn't close the
// whole modal or disturb another tab's unsaved edits. `dimensions` is an
// array of { key, mode, label, defaultTypes, defaultNextValue } — no
// onCancel is passed to each TypesEditor since "cancel" for a single tab
// among several is ambiguous; the modal's own close (X / outside click)
// covers that.
export function ManageTypesTabsModal({ open, onClose, dimensions }) {
  return (
    <Modal
      open={open}
      title="Manage Types"
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      width={600}
    >
      <Tabs
        items={dimensions.map(({ key, mode, label, defaultTypes, defaultNextValue }) => ({
          key,
          label,
          // Tabs are lazy by default — only the active pane mounts, so an
          // inactive tab's TypesEditor wouldn't fetch until first clicked.
          // forceRender mounts all three up front, so switching tabs never
          // shows a loading spinner for data that's already available.
          forceRender: true,
          children: (
            <TypesEditor
              mode={mode}
              title={label}
              defaultTypes={defaultTypes}
              defaultNextValue={defaultNextValue}
            />
          ),
        }))}
      />
    </Modal>
  );
}
